module.exports = __webpack_public_path__ + "media/A6.d79d5c1a.mp3";